<template>
  <div element-loading-spinner="qc-spinner" :loading="loadingVolumeData" v-loading="loadingVolumeData" >
    <canvas id="volumeGraph"></canvas>
  </div>
</template>
  
<script>
import Chart from "chart.js";
import { mapGetters, mapState } from "vuex";
import { utils, writeFile } from 'xlsx'
import moment from 'moment'
export default {
  name: "account-graph",
  components: {
    Chart,
  },
  data() {
    return {
      loadingVolumeData: false,
      volumeData: null,
      chartName: "",
      chart: "",
      sidebarStore: false,

      // BELOW: AN EXAMPLE OF HOW TO USE PREVIOUS DATASETS IF SECOND LINE NEEDED TO BE ADDED 
      //   datasets: [
      //     {
      //       label: 'Current 24 Month Volume',
      //       borderColor: '#3CA5AA',
      //       fill: false,
      //       borderWidth: 2,
      //       tension: 0.1,
      //       pointRadius: 1,
      //       data: [5, 5, 5, 5, 10, 10, 10, 5, 10, 5, 10, 15, 10, 5, 5, 10, 10, 10, 15, 10, 15, 20, 15, 20, 25, 25],
      //     },
      //     // {
      //     //   label: "Last 24 Month's Volume",
      //     //   borderColor: 'lightgrey',
      //     //   fill: false,
      //     //   borderWidth: 2,
      //     //   tension: 0.3,
      //     //   pointRadius: 2,
      //     //   data: [0, 0, 0, 5, 10, 5, 5, 5, 10, 5, 10, 5, 10, 5, 5, 10, 15, 10, 15, 10, 10, 10, 5, 10, 5, 10, 5, 10, 10, 15, 10, 15, 10, 10, 10, 5, 5, 5, 10],
      //     // }
      //   ]
      // },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: true,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              precision: 0,
              suggestedMax: 5,
            }
          }],
          xAxes: [{
            gridLines: {
                color: "rgba(0, 0, 0, 0)",
            }
          }],
          yAxes: [{
            gridLines: {
                            color: "rgba(0, 0, 0, 0)",
                        },
                        ticks: {
                          precision: 0,
                          suggestedMax: 5,
                        }
          }]
        },
        legend: {
          display: false
        },
      },
      chartData: {
        labels: [],
        datasets: [
          {
            label: 'Volume',
            borderColor: '#3ca5aa',
            pointBorderColor: '#2e8084',
            pointBackgroundColor: "#FEFEFE",
            fill: false,
            borderWidth: 2,
            tension: 0.3,
            pointRadius: 4,
            data: [],
          },
        ]
      }
    };
  },
  async mounted() {
    this.$store.state.volumeChartName = "Monthly (12)"
    this.chartName = this.$store.state.volumeChartName
  },
  beforeDestroy() {
    this.$store.state.volumeChartName = ""
  },
  methods: {
    downloadData() {
            let downloadData = {
                date: [],
                volume: [],
            }
            for (let i = 0; i < this.chartData.datasets[0].data.length; i++) {
                downloadData.date.push(this.chartData.labels[i])
                downloadData.volume.push(this.chartData.datasets[0].data[i])
            }
            const data = downloadData.date.map((date, i) => ({
                Date: date,
                "Volume": downloadData.volume[i]
            }));
            const worksheet = utils.json_to_sheet(data);
            const workbook = utils.book_new()
            utils.book_append_sheet(workbook, worksheet, "Volume Data")
            writeFile(workbook, "Volume_Data.xlsx")
        },
    async setVolumeData() {
      this.loadingVolumeData = true;
      this.chartData.labels = []
      this.chartData.datasets[0].data = []
      this.counter = this.chartName.substring(0, this.chartName.length - 1).slice(-2)
      await this.$api.getVolumeData(this.counter)
        .then(response => {
          this.volumeData = response.data
          for (let i = 0; i < this.volumeData.currentPeriod.length; i++) {
            if (this.counter == 52) {
              var s = this.volumeData.currentPeriod[i].date.split(" ")
              this.chartData.labels.push(moment().day("Monday").week(s[0]).format("Do MMM"))
            } else {
              this.chartData.labels.push(this.volumeData.currentPeriod[i].date)
            }
            this.chartData.datasets[0].data.push(this.volumeData.currentPeriod[i].count)
          }
        }).catch(error => {
          console.log("ERROR", error)
        })
      if (this.chart != "") {
        this.loadingRevenueData = false
        this.chart.update()
      } else {
        this.chartConstructor();
      }
      this.loadingVolumeData = false;
    },
    chartConstructor() {
      const chartElement = document.getElementById("volumeGraph");
        this.chart = new Chart(chartElement, {
          type: "line",
          data: this.chartData,
          options: this.chartOptions,
        });
        this.loadingVolumeData = false
    },
  },
  computed: {
    ...mapState(["volumeChartName", "downloadVolumeSheet"]),
    ...mapGetters({
      newVolumeChart: "getVolumeChartName",
      newDownloadVolumeSheet: "getDownloadVolumeSheet"
    }),
  },
  watch: {
    newVolumeChart: async function (val) {
        this.chartName = val
        this.setVolumeData()
    },
    newDownloadVolumeSheet: function (val) {
      if(val == true) {
        this.downloadData()
      }
      this.$store.state.downloadVolumeSheet = false;
    }
  },
};
</script>